import request from "@/utils/request";

export function isJump(params) {
  return request({
    url: `/channel/judge`,
    method: "GET",
    headers: {
      ...params,
      loading: false,
      unDecode: 1,
    },
  });
}

export function sendSmsCode(mobile) {
  return request({
    url: `/sendCode`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
    params: {
      mobile,
    },
  });
}

export function getContent(data) {
  return request({
    url: `/content/get`,
    method: "POST",
    headers: {
      loading: false,
      unDecode: 1,
      needToken: "no",
    },
    data,
  });
}

export function getRegions(id) {
  return request({
    url: `/regions/${id}/children`,
    method: "GET",
    headers: {
      loading: false,
      unDecode: 1,
    },
  });
}

export function addGpsRecord(params) {
  return request({
    url: `api/location/addGpsRecord`,
    method: "POST",
    headers: {
      loading: false,
      unDecode: 1,
    },
    data: params,
  });
}

export function login(params) {
  return request({
    url: `/h5Login`,
    method: "POST",
    headers: {
      channel: params.channel,
      unDecode: 1,
    },
    data: {
      mobile: params.mobile,
      code: params.code,
      // deviceModel: getMobSysInfo(),
    },
  });
}

export function loanApply(data) {
  return request({
    url: `/car/loan/apply`,
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function getDownloadUrl(channel) {
  let model = window.sessionStorage.getItem("model");
  const header = model === "modeldlb" ? "ANEHUA" : "";
  return request({
    url: `/channel/download`,
    method: "GET",
    headers: {
      cSource: header,
      channel,
      unDecode: 1,
    },
  });
}

//海尔专用下载接口
//prodiff
//  1:放款流程
//  2: 贷超流程
export function getDownloadUrlWithHaier(channel, prodiff) {
  return request({
    url: `/channel/download`,
    method: "GET",
    headers: {
      channel,
      prodiff: prodiff,
      unDecode: 1,
    },
  });
}

export function checkIdCard(data) {
  return request({
    url: `/user/checkIdCard`,
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function queryProductList(data) {
  return request({
    url: "/product/api/h5CpaProductPageList",
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function buried(data) {
  return request({
    url: "/product/api/addLoanRecord",
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function queryFormItem() {
  return request({
    url: "/registerDataType",
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function submitAnEntry(data) {
  let userId = window.localStorage.getItem("userId");
  return request({
    url: "/assetAndApplyV2",
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data: {
      ...data,
      userId,
    },
  });
}

export function submitAnEntryTouTiao(data) {
  return request({
    url: "/touTiaoRegisterAndApply",
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function queryRiskWarning(channelNo) {
  return request({
    url: `/channel/landingPageAttr/${channelNo}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

// 根据渠道code获取推荐产品
export function getChannleProductList(code) {
  let userId = window.localStorage.getItem("userId");
  if (userId === undefined || userId == null) {
    userId = 0;
  }
  return request({
    url: `/channel/queryChannleProduct/${code}/${userId}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

//获得联登的登陆地址
export function getRegister2CompanyUrl(cpaId, hitRecordId) {
  let userId = window.localStorage.getItem("userId");
  if (userId === undefined || userId == null) {
    userId = 0;
  }

  return request({
    url: `/channel/doRegister2Other/${cpaId}/${userId}/${hitRecordId}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function getUnionLogin4ClickV3(cpaId, hitRecordId) {
  let userId = window.localStorage.getItem("userId");
  if (userId === undefined || userId == null) {
    userId = 0;
  }
  return request({
    url: `/channel/getUnionLogin4ClickV3/${cpaId}/${hitRecordId}/${userId}`,
    method: "GET",
    headers: {
      needToken: true,
      unDecode: 1,
    },
  });
}
// 根据渠道code和step值获取弹窗配置的最高权重
export function getPopItem(code) {
  let userId = window.localStorage.getItem("userId");
  if (userId === undefined || userId == null) {
    userId = 0;
  }
  return request({
    url: `/product/api/getpopitem?xid=${userId}&code=${code}&step=3`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

//获取是否屏蔽城市
export function getIsShieldCity(code) {
  const headers = {
    unDecode: 1,
  };
  // 从 localStorage 获取 lendul
  const lendul = window.localStorage.getItem("lendul");
  // 如果 lendul 有值，则添加到 headers 中
  if (lendul) {
    headers.lendul = lendul;
  }
  return request({
    url: `/channel/isShieldCity?source=${code}`,
    method: "GET",
    headers: headers,
  });
}
//获取信业帮url phone channelCode
export function getXYBLinkUrl(data) {
  return request({
    url: "/agency/xy/checkIsExist",
    method: "POST",
    headers: {
      needToken: true,
      unDecode: 1,
    },
    data,
  });
}

export function getRegister2Logo(source) {
  return request({
    url: `/channel/logo/${source}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function getPopupProductList(source) {
  let userId =
    window.localStorage.getItem("userId") === "undefined" ||
    window.localStorage.getItem("userId") === null
      ? 0
      : window.localStorage.getItem("userId");
  return request({
    url: `/product/api/getPopControllerList?xid=${userId}&code=${source}&step=2`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function channelIncomingControl(source) {
  return request({
    url: `/channel/getLandingPageByChannel?source=${source}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function getUser2WhereApi() {
  let userId =
    window.localStorage.getItem("userId") === "undefined" ||
    window.localStorage.getItem("userId") === null
      ? 0
      : window.localStorage.getItem("userId");
  let model = window.sessionStorage.getItem("model");
  const header = model === "modeldlb" ? "ANEHUA" : "";
  return request({
    url: `/channel/getUser2WhereApiV2?userId=${userId}`,
    method: "GET",
    headers: {
      cSource: header,
      unDecode: 1,
    },
  });
}
export function getProductByUserV2(channel) {
  let userId =
    window.localStorage.getItem("userId") === "undefined" ||
    window.localStorage.getItem("userId") === null
      ? 0
      : window.localStorage.getItem("userId");
  return request({
    url: `/api/share/getProductByUserV2?userId=${userId}&channel=${channel}`,
    method: "POST",
    headers: {
      unDecode: 1,
    },
  });
}
export function getProductsInResultPage(channel) {
  let userId =
    window.localStorage.getItem("userId") === "undefined" ||
    window.localStorage.getItem("userId") === null
      ? 0
      : window.localStorage.getItem("userId");
  return request({
    url: `/api/h/getProductsInResultPage?userId=${userId}&channelCode=${channel}`,
    method: "POST",
    headers: {
      unDecode: 1,
    },
  });
}

export function getUnionLogin() {
  let userId =
    window.localStorage.getItem("userId") === "undefined" ||
    window.localStorage.getItem("userId") === null
      ? 0
      : window.localStorage.getItem("userId");
  let model = window.sessionStorage.getItem("model");
  const header = model === "modeldlb" ? "ANEHUA" : "";
  return request({
    url: `/channel/getUnionLogin?userId=${userId}`,
    method: "GET",
    headers: {
      cSource: header,
      unDecode: 1,
    },
  });
}

export function getApiResultsInfo(data) {
  return request({
    url: `/api/agency/access/getInfo`,
    method: "POST",
    headers: {
      unDecode: 1,
    },
    data,
  });
}

export function callPushData(data) {
  return request({
    url: `/api/agency/access/callPushData`,
    method: "POST",
    headers: {
      unDecode: 1,
    },
    data,
  });
}
//11：真实姓名 12:真实年龄 13:性别 14贷款金额 15:资产选项 16: 芝麻分 17:获取额度 18验证码
export function delayModel8SUpdate(source, second, tid, index) {
  return request({
    url: `/channel/addStagRecordWithStep/${source}/${second}/${tid}/${index}`,
    method: "POST",
    headers: {
      loading: false,
      unDecode: 1,
    },
  });
}

export function delayModel9SUpdate(source, second, tid, index, thirdPartId) {
  return request({
    url: `/channel/addStagRecordWithStep/${source}/${second}/${tid}/${index}/${thirdPartId}`,
    method: "POST",
    headers: {
      loading: false,
      unDecode: 1,
    },
  });
}

//惠逸花 产品申请
export function getHYHProductData(data, agentCode) {
  return request({
    url: `/api/agency/${agentCode}/push`,
    method: "POST",
    headers: {
      loading: false,
      unDecode: 1,
    },
    data,
  });
}

//腰部数据点击同意协议埋点
export function middleDataEventTracking(pushRecordId, thirdPartyId) {
  return request({
    url: `agency/manualGrant?pushRecordId=${pushRecordId}&thirdPartyId=${thirdPartyId}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

/*
 * 跳转第三方 && 存储跳转记录
 * redirectUrl 跳转地址
 * data 请求参数
 * */
export function toRedirectUrlAndSaveRecord(redirectUrl, data) {
  function debounce(func, delay) {
    let timer;
    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const handlePushPopProductDebounced = debounce(() => {
    window.location.href = redirectUrl;
    buried(data).catch((error) => {
      console.error("Buried API call failed:", error);
    });
  }, 300);
  handlePushPopProductDebounced();
}

/*
 * 跳转第三方 && 存储跳转记录(无防抖)
 * redirectUrl 跳转地址
 * data 请求参数
 *
 */
export function toRedirectUrlAndSaveRecordNoDebounce(
  redirectUrl,
  data,
  isWeCom = 0
) {
  if (isWeCom) {
    localStorage.setItem(
      "wxjq_date",
      JSON.stringify({
        showPage: data.showPage,
        id: data.productId,
        linkUrl: redirectUrl,
      })
    );
    window.location.href = `${location.origin}/wxjq`;
  } else {
    // 确保埋点请求触发后再跳转
    buried(data)
      .catch((error) => {
        console.error("Buried API call failed:", error);
      })
      .finally(() => {
        window.location.href = redirectUrl;
      });
  }
}

export function getUnionToken(token) {
  return request({
    url: `api/ul/getUnionToken/${token}`,
    method: "GET",
    headers: {
      unDecode: 1,
    },
  });
}

export function getUserDetail4Show(token) {
  return request({
    url: `/user/getUserDetail4Show`,
    method: "GET",
    headers: {
      unDecode: 1,
      needToken: true,
      Authorization: token,
    },
  });
}

export function addDownloadRecord(channel) {
  let userId = window.localStorage.getItem("userId");
  if (userId === undefined || userId == null) {
    userId = 0;
  }

  return request({
    url: `/channel/addDownloadRecord/${channel}/${userId}`,
    method: "POST",
    headers: {
      unDecode: 1,
      channel: channel,
    },
  });
}

export function getCityLocation() {
  return request({
    url: `/regions/getCityLocation`,
    method: "GET",
    headers: {
      loading: false,
      unDecode: 1,
    },
  });
}
